import { SVGProps, Ref, forwardRef } from 'react';

export const EmptySize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <rect x={-1} y={-1} width={34} height={34} stroke="currentColor" strokeWidth={2} />
            </g>
        </g>
    </svg>
));
EmptySize32Glyph.displayName = 'EmptySize32Glyph';
